import React, { useState, useEffect } from 'react'
import Card from '../../../components/ui/Card'
import Icon from '../../../components/AppIcon'

const QuoteTimer = ({ startTime, duration, onExpired }) => {
  const [remaining, setRemaining] = useState(duration)

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime
      const newRemaining = Math.max(0, duration - elapsed)
      setRemaining(newRemaining)

      if (newRemaining <= 0) {
        clearInterval(interval)
        onExpired()
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [startTime, duration, onExpired])

  const minutes = Math.floor(remaining / 60000)
  const seconds = Math.floor((remaining % 60000) / 1000)
  const progress = (remaining / duration) * 100

  const isLow = remaining < 60000 // Less than 1 minute

  return (
    <Card variant="solid" padding="none" className={`rounded-xl border bg-white px-5 py-4 shadow-none ${isLow ? 'border-destructive' : 'border-[#DCDFE5]'}`}>
      <div className="mb-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Icon
            name="Clock"
            size={16}
            className={isLow ? 'text-destructive' : 'text-[#656C78]'}
          />
          <span className={`text-sm font-medium ${isLow ? 'text-destructive' : 'text-[#17191D]'}`}>
            Quote Timer
          </span>
        </div>
        <span className={`text-xl font-semibold tracking-tight tabular-nums ${isLow ? 'text-destructive' : 'text-[#17191D]'}`}>
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-1 overflow-hidden rounded-full bg-[#EDF0F4]">
        <div
          className={`h-full transition-all duration-1000 rounded-full ${
            isLow ? 'bg-destructive' : 'bg-[#2457DB]'
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>

      <p className={`mt-2.5 text-xs ${isLow ? 'text-destructive' : 'text-[#656C78]'}`}>
        {isLow ? 'Price lock expiring soon!' : 'Price locked at current rate'}
      </p>
    </Card>
  )
}

export default QuoteTimer
